import EventEmitter from 'events'

const PriorityQueue = function (options) {
    EventEmitter.call(this)
    this.queue = {}
    this.sortedPriorities = []
    this.length = 0
    this.inProgress = 0

    const defaultOptions = {
        concurrency: 1,
        defaultPriority: 0,
        autoStart: true,
    }
    Object.assign(this.options = {}, defaultOptions, options)
    this.started = this.options.autoStart
    this.counter = 0
}

PriorityQueue.prototype = EventEmitter.prototype

PriorityQueue.prototype.claimNext = function () {
    var prioIndex = 0
    while (prioIndex < this.sortedPriorities.length) {
        const prio = this.sortedPriorities[prioIndex]

        // End of queue
        if (this.queue[prio].length == 0) {
            prioIndex++
            continue;
        }

        const callback = this.queue[prio].shift()
        this.length--
        return callback
    }
    return null
}

PriorityQueue.prototype.processNext = async function () {
    if (!this.started) return null
    if (this.length <= 0) return null
    if (this.inProgress >= this.options.concurrency) return null
    const nextItem = this.claimNext()
    if (!nextItem) return null
    this.inProgress++
    try {
        await nextItem()
    }
    catch (error) {
        console.log(error)
    }
    this.inProgress--

    if (this.length == 0 && this.inProgress == 0) {
        // Queue is empty
        this.emit('stopped')
        this.emit('empty')
    }
    if (this.length > 0 && this.started) {
        // Queue is not empty, and queue is still running empty
        this.processNext()
    }
    if (!this.started && this.inProgress == 0) {
        // Queue has been stopped, and remaining running items are finished
        this.emit('stopped')
    }
}

PriorityQueue.prototype.push = async function (callback, prio = null) {
    prio = prio == null ? this.options.defaultPriority : prio
    if (!this.queue[prio]) {
        this.queue[prio] = []
        this.sortedPriorities = Object.keys(this.queue).sort()
    }
    const promise = new Promise((resolve, reject) => {
        this.queue[prio].push(async () => {
            try {
                resolve(await callback())
            } catch(error) {
                reject(error)
            }
        })
        this.length++
        this.processNext()
    })
    return promise
}

PriorityQueue.prototype.start = async function () {
    this.started = true
    const promise = this.promiseEmpty()
    this.processNext()
    return promise
}

PriorityQueue.prototype.stop = async function () {
    this.started = false
    const promise = this.promiseStopped()
    this.processNext()
    return promise
}

PriorityQueue.prototype.isEmpty = function () {
    return this.length == 0
}

PriorityQueue.prototype.promiseEmpty = function () {
    const self = this
    return new Promise(function (resolve, reject) {
        const resolver = function () {
            self.off('empty', resolver)
            resolve()
        }

        self.on('empty', resolver)
    })
}

PriorityQueue.prototype.promiseStopped = function () {
    const self = this
    return new Promise(function (resolve, reject) {
        const resolver = function () {
            self.off('stopped', resolver)
            resolve()
        }

        self.on('stopped', resolver)
    })
}

export default PriorityQueue
